<h2 mat-dialog-title>Registra un evento fiscale</h2>


<form #EventForm="ngForm" (ngSubmit)="addNewEvent()" class="event-form">

<mat-dialog-content>

        <h6 class="mb-3">Dettagli evento:</h6>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-100">
            <mat-label>Nome evento</mat-label>
            <input
              matInput
              [(ngModel)]="newEvent.name"
              name="name"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>Tipo</mat-label>
            <mat-select
              [(ngModel)]="newEvent.type"
              name="type"
              required
            >
              <mat-option *ngFor="let type of typeOptions" [value]="type.code">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-50-mobile-50">
            <mat-label>importo</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="newEvent.amount"
              name="amount"
              required
            />
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field appearance="outline" class="w-sm-100">
            <mat-label>Descrizione (opzionale)</mat-label>
            <input
              matInput
              type="string"
              [(ngModel)]="newEvent.description"
              name="description"
            />
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-sm-100">
            <mat-label>Data di emissione</mat-label>
            <input
              matInput
              [matDatepicker]="emissionDatePicker"
              [(ngModel)]="newEvent.date"
              name="date"
              required
            />
            <!-- (ngModelChange)="onEmissionDateChange($event)" -->
            <mat-datepicker-toggle
              matSuffix
              [for]="emissionDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #emissionDatePicker></mat-datepicker>
          </mat-form-field>

          <p>Questo evento verrà considerato già pagato.</p>
        </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button 
    mat-button 
    class="pink-muted-button"
    mat-dialog-close>
    Esci
  </button>
  <button
      mat-raised-button
      type="submit"
      [disabled]="!EventForm.valid"
      class="align-self-end pink-button"
    >
    <mat-icon>add</mat-icon>
      Aggiungi
  </button>
</mat-dialog-actions>

</form>
